import type { TFunction } from 'i18next';
import type { InventoryLevel } from '@interfaces/ILogistics';
import { etaLate, formatDay } from '../logistics.format';

/**
 * The words for an in-flight delivery on a stock row — one set, whatever the
 * row's own state (covered, or ran out while the truck is on its way).
 *
 * An agreed date is a commitment and reads as one ("arriving 8/12"); a due
 * date nobody answered says so in words ("estimated to arrive"). An ETA that
 * has already elapsed is not an arrival time: past its own date the line
 * reports the shortfall instead. No date on the order, no date on the row —
 * the bare "New delivery arriving" IS the "ETA not set" case.
 */
export function incomingLine(level: InventoryLevel, tz: string, lang: string, t: TFunction): string {
  if (level.incomingEta == null) return t('logistics.inventory.deliveryIncoming');
  const late = etaLate(level, tz);
  const date = formatDay(level.incomingEta, lang);
  if (late > 0) {
    return t(
      level.incomingEtaExact
        ? 'logistics.inventory.deliveryIncomingLateOn'
        : 'logistics.inventory.deliveryIncomingLateAbout',
      { n: late, date },
    );
  }
  return t(
    level.incomingEtaExact ? 'logistics.inventory.deliveryIncomingOn' : 'logistics.inventory.deliveryIncomingAbout',
    { date },
  );
}
